import { type ButtonBaseActions, Radio } from '@mui/material'
import { forwardRef, useImperativeHandle, useRef } from 'react'

// A Radio component that exposes a focus method that shows the focus visible state on it.
// By default the MUI Radio does not show the focus visible state when focused programmatically.
const FocusVisibleRadioBase = (
	props: Omit<React.ComponentProps<typeof Radio>, 'action' | 'inputRef'>,
	ref: React.Ref<HTMLButtonElement>
) => {
	const actionRef = useRef<ButtonBaseActions>(null)
	const radioRef = useRef<HTMLButtonElement>(null)
	useImperativeHandle(
		ref,
		() => ({
			...(radioRef.current as HTMLButtonElement),
			focus: () => {
				radioRef.current?.focus()
				actionRef.current?.focusVisible()
				radioRef.current?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				})
			},
		}),
		[]
	)
	return <Radio {...props} action={actionRef} ref={radioRef} />
}
const FocusVisibleRadio = forwardRef(FocusVisibleRadioBase)

export { FocusVisibleRadio }
